import translation from '../../../i18n/translation';
import { Space, Typography } from 'antd';
import styles from '../delayAndStatusModal.module.scss';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { IAppointmentStatus } from '../../../constants/types';

const { Text } = Typography;

interface Props {
  status: string;
}

const StatusChangeNotification: React.FC<Props> = ({ status }) => {
  return (
    <Space direction="vertical">
      <Space className={styles.flexAlignCenter}>
        <ExclamationCircleFilled
          style={{ fontSize: '24px', color: '#FFC53D' }}
        />{' '}
        <Text className={styles.heading}>
          {status === IAppointmentStatus.completed
            ? translation('cannot_change_status_to_completed')
            : translation('cannot_change_status_to_in_progress')}
        </Text>
      </Space>
      {status === IAppointmentStatus.completed ? (
        <Space direction="vertical" style={{ padding: '8px 8px 0 42px' }}>
          <Text>{translation('status_change_completed_message')}</Text>
          <Text>
            &#8226; {translation('status_change_completed_first_condition')}
          </Text>
          <Text>
            &#8226; {translation('status_change_completed_second_condition')}
          </Text>
        </Space>
      ) : (
        <Space direction="vertical" style={{ padding: '8px 8px 0 42px' }}>
          <Text>{translation('status_change_in_progress_message')}</Text>
        </Space>
      )}
    </Space>
  );
};

export default StatusChangeNotification;
